import { render } from "./DefaultPageView.vue?vue&type=template&id=55aa22ba"
import script from "./DefaultPageView.vue?vue&type=script&lang=js"
export * from "./DefaultPageView.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__